import { render } from "./WebSkillRankingSkeleton.vue?vue&type=template&id=f2db3c98&scoped=true"
import script from "./WebSkillRankingSkeleton.vue?vue&type=script&lang=js"
export * from "./WebSkillRankingSkeleton.vue?vue&type=script&lang=js"

import "./WebSkillRankingSkeleton.vue?vue&type=style&index=0&id=f2db3c98&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2db3c98"]])

export default __exports__